// extracted by mini-css-extract-plugin
export var item = "Postitem-module--item--rPW7o";
export var item__category = "Postitem-module--item__category--cmYPa";
export var item__cover = "Postitem-module--item__cover--2mho+";
export var item__title = "Postitem-module--item__title--+b+M7";
export var large = "Postitem-module--large--+4Rcf";